import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { stateKorea } from '../../utils/Languages';
import SignUpDate from '../components/SignUpDate';
import buskwarehousedetail from '../services/buskwarehousedetail';
import { Tabs } from 'antd';
import LogisticInformation from '../components/LogisticInformation';
import SellerContract from '../containers/SellerContract';
import ReturnDisposalList from '../containers/ReturnDisposalList';
import ReturnProduct from '../containers/ReturnProduct';
import LogisticCenter from '../containers/LogisticCenter';
import ShippingList from '../containers/ShippingList';

const BuskWarehouseDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [tabChange, setTabChange] = useState('1');
  const checkTabState = (tabChange: string) => {
    switch (tabChange) {
      case '1':
        return '물류센터 상세';
      case '2':
        return '셀러계약 목록';
      case '3':
        return '상품 목록';
      case '4':
        return '배송 목록';
      case '5':
        return '반환/폐기 목록 (입고,재고)';
      case '6':
        return '반환/폐기 목록 (주문)';
      default:
        return '물류센터 상세';
    }
  };

  const listBreadcrumb = [
    {
      tittle: '물류센터 관리',
      url: '/admin/busk/logistic'
    },
    {
      tittle: checkTabState(tabChange),
      url: ''
    }
  ];
  // Logistic Center information
  const [formData, setFormData] = useState();

  //loading
  const handleTabChange = (key: string) => {
    setTabChange(key);
  };

  const getWarehouseDetail = async () => {
    const buskWarehouseDetail = await buskwarehousedetail.getWarehouseDetail(
      id
    );
    setFormData({
      ...buskWarehouseDetail.data,
      accountState: stateKorea(buskWarehouseDetail.data.accountState),
      updatedAt: formatDateTime(buskWarehouseDetail.data.updatedAt)
    });
  };

  useEffect(() => {
    getWarehouseDetail();
  }, []);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="busk-container">
        <SignUpDate formData={formData} />
        <div className="busk-tabs">
          <Tabs
            defaultActiveKey="1"
            onChange={(e) => {
              handleTabChange(e);
            }}
          >
            <Tabs.TabPane tab="물류센터 정보" key="1">
              <LogisticInformation formData={formData} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="셀러 계약 목록" key="2">
              <SellerContract />
            </Tabs.TabPane>
            <Tabs.TabPane tab="상품 목록" key="3">
              <LogisticCenter />
            </Tabs.TabPane>
            <Tabs.TabPane tab="배송 목록" key="4">
              <ShippingList />
            </Tabs.TabPane>
            <Tabs.TabPane tab="반환/폐기 목록 (입고,재고)" key="5">
              <ReturnDisposalList />
            </Tabs.TabPane>
            <Tabs.TabPane tab="반환/폐기 목록 (주문)" key="6">
              <ReturnProduct />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
};
export default BuskWarehouseDetail;
